import { render, staticRenderFns } from "./DTSCreate.vue?vue&type=template&id=fc2c2d02&"
import script from "./DTSCreate.vue?vue&type=script&lang=js&"
export * from "./DTSCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports